import { render, staticRenderFns } from "./Dispatching.vue?vue&type=template&id=1b4f89bf&scoped=true&"
import script from "./Dispatching.vue?vue&type=script&lang=js&"
export * from "./Dispatching.vue?vue&type=script&lang=js&"
import style0 from "./Dispatching.vue?vue&type=style&index=0&id=1b4f89bf&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&id=1b4f89bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f89bf",
  null
  
)

export default component.exports